import MDEditor from '@uiw/react-md-editor';
import { ko } from 'date-fns/locale';
import moment from 'moment-timezone';
import React, { SetStateAction, useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import toast from 'react-hot-toast';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import DetectorController from '../../../controller/DetectorController';
import NoticeController from '../../../controller/NoticeController';
import StoreController from '../../../controller/StoreController';
import Editor from './Editor';

registerLocale('ko', ko);

interface FilterStoreProps {
  filterStatus: number;
  selectedList: number[];
  setSelectedList: React.Dispatch<SetStateAction<number[]>>;
  selectedHotel: HotelSelectType | null;
  setSelectedHotel: React.Dispatch<SetStateAction<HotelSelectType | null>>;
  hotelList: HotelSelectType[];
  storeList: HotelSelectType[];
}

type HotelSelectType = {
  name: string;
  id: number;
};

const RenderFilterStore = ({
  filterStatus,
  selectedList,
  setSelectedList,
  selectedHotel,
  setSelectedHotel,
  hotelList,
  storeList,
}: FilterStoreProps) => {
  const [keyword, setKeyword] = useState<string>('');
  const [searchedList, setSearchedList] = useState<HotelSelectType[]>([]);

  const [hotelKeyword, setHotelKeyword] = useState<string>('');
  const [hotelSearched, setHotelSearched] = useState<HotelSelectType[]>([]);

  const handleCheckboxClick = (item: number) => {
    if (selectedList.filter((item) => item === -1).length === 0) {
      if (selectedList.find((option) => option === item)) {
        setSelectedList([...selectedList.filter((option) => option !== item)]);
      } else {
        setSelectedList([...selectedList, item]);
      }
    }
  };

  const searchHotel = () => {
    setHotelSearched(hotelList.filter((item) => item.name.includes(hotelKeyword)));
  };

  const selectMappingHotel = (item: HotelSelectType) => {
    setSelectedHotel(item);
    setHotelKeyword('');
    setHotelSearched([]);
  };

  const getSearchResult = () => {
    if (filterStatus === 1) {
      setSearchedList(storeList.filter((item) => item.name.includes(keyword)));
    } else if (filterStatus === 2 || filterStatus === 3) {
      setSearchedList(hotelList.filter((item) => item.name.includes(keyword)));
    }
  };

  const checkAllItem = () => {
    if (selectedList.filter((item) => item === -1).length > 0) {
      setSelectedList([]);
    } else {
      setSelectedList([-1]);
    }
  };

  const checkAllListItem = () => {
    if (selectedList.filter((item) => item === -1).length === 0) {
      if (searchedList.every((item) => selectedList.includes(item.id))) {
        setSelectedList((prev) =>
          prev.filter((item) => !searchedList.some((searchedItem) => searchedItem.id === item)),
        );
      } else {
        const newArray = searchedList.map((item) => item.id);
        setSelectedList((prev) => Array.from(new Set([...prev, ...newArray])));
      }
    }
  };

  useEffect(() => {
    setKeyword('');
    setSearchedList([]);
    setSelectedList([]);
  }, [filterStatus]);

  useEffect(() => {
    getSearchResult();
  }, [storeList]);

  return (
    <div className="inputArea">
      <label htmlFor="all_check" className="all">
        <h5>전체 대상</h5>
        <input
          id="all_check"
          type="checkbox"
          autoFocus={false}
          checked={
            // searchedList.length > 0 && searchedList.every((item) => selectedList.includes(item.id))
            selectedList.filter((item) => item === -1).length > 0
          }
          onChange={checkAllItem}
        />
      </label>
      {filterStatus === 1 && (
        <>
          <div className="inputWrap">
            <input
              value={hotelKeyword}
              placeholder="호텔의 매핑된 매장을 찾고 싶다면 호텔명을 입력하세요"
              onChange={(e) => setHotelKeyword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  searchHotel();
                }
              }}
            />
            <button onClick={searchHotel}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
            </button>
          </div>
          {hotelSearched.length > 0 ? (
            <div className="resultBox min">
              {hotelSearched.map((item, index) => (
                <div key={index} className="resultItem" onClick={() => selectMappingHotel(item)}>
                  <h4>{item.name}</h4>
                </div>
              ))}
            </div>
          ) : (
            selectedHotel && (
              <div className="mappingItem">
                <h3>{selectedHotel.name}</h3>
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_close_white.svg`}
                  alt="close"
                  onClick={() => setSelectedHotel(null)}
                />
              </div>
            )
          )}
        </>
      )}
      <div className="inputWrap">
        <input
          value={keyword}
          placeholder="검색어를 입력하세요 (검색어가 없다면 전체 리스트 보여줍니다)"
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              getSearchResult();
            }
          }}
        />
        <button onClick={getSearchResult}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
        </button>
      </div>
      <label htmlFor="all_item" className="all">
        <h5>목록 모두 선택</h5>
        <input
          id="all_item"
          type="checkbox"
          autoFocus={false}
          checked={
            searchedList.length > 0 && searchedList.every((item) => selectedList.includes(item.id))
          }
          onChange={checkAllListItem}
        />
      </label>
      <div className="resultBox">
        {searchedList.length > 0 ? (
          searchedList.map((item, index) => (
            <label
              key={index}
              htmlFor={`check_${index}`}
              className={`resultItem ${
                selectedList.filter((option) => option === item.id).length > 0 && 'active'
              }`}>
              <h4>{item.name}</h4>
              <input
                id={`check_${index}`}
                type="checkbox"
                autoFocus={false}
                checked={selectedList.filter((option) => option === item.id).length > 0}
                onChange={() => handleCheckboxClick(item.id)}
              />
            </label>
          ))
        ) : (
          <h2>검색 결과가 없어요</h2>
        )}
      </div>
    </div>
  );
};

const NoticeEdit = () => {
  const { notice_id } = useParams();
  const location = useLocation();

  const navigate = useNavigate();

  const [title, setTitle] = useState<string>('');

  const [filterStatus, setFilterStatus] = useState<number>(0);

  const [hotelList, setHotelList] = useState<HotelSelectType[]>([]);
  const [storeList, setStoreList] = useState<HotelSelectType[]>([]);

  const [selectedHotel, setSelectedHotel] = useState<HotelSelectType | null>(null);
  const [selectedList, setSelectedList] = useState<number[]>([]);

  const [isShow, setIsShow] = useState<boolean>(true);

  const [isStartInfinite, setIsStartInfinite] = useState<boolean>(false);
  const [isEndInfinite, setIsEndInfinite] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());

  const [content, setContent] = useState<string | undefined>('');
  const [themeColor, setThemeColor] = useState<number>(0); // 0: white, 1: black

  const onChange_content = (e: string | undefined) => {
    setContent(e);
  };

  // API 호출
  const getHotelList = async () => {
    try {
      const response = await DetectorController.getHotelList();

      if (response && response.data) {
        const formattedHotelList = response.data.data.map((item: any) => ({
          name: item.store_name,
          id: item.store_id,
        }));
        setHotelList(formattedHotelList);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const getStoreMetaByHotel = async () => {
    try {
      const oParams = selectedHotel
        ? {
            hotel_store_id: selectedHotel.id,
          }
        : undefined;
      const response = await StoreController.getStoreMetaByHotel(oParams);

      if (response && response.data) {
        const formattedHotelList = response.data.data.map((item: any) => ({
          id: item.store_id,
          name: item.store_name,
        }));
        setStoreList(formattedHotelList);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const getdetail = async () => {
    const oParams = {
      notice_id: Number(notice_id),
    };

    const oRes = await NoticeController.getdetail(oParams);

    if (oRes && oRes.data) {
      const oResponse = oRes.data;
      if (oResponse.data) {
        setTitle(location.state.title);
        setContent(oResponse.data.content);
        setIsShow(oResponse.data.is_published === 1);
        if (oResponse.data.published_from) {
          setStartDate(new Date(oResponse.data.published_from));
          setIsStartInfinite(false);
        } else {
          setIsStartInfinite(true);
        }
        if (oResponse.data.published_to) {
          setEndDate(new Date(oResponse.data.published_to));
          setIsEndInfinite(false);
        } else {
          setIsEndInfinite(true);
        }
        if (oResponse.data.permission_groups) {
          oResponse.data.permission_groups.map((item: any) => {
            setFilterStatus(item.permission_type);
            setTimeout(() => {
              setSelectedList(item.store_ids.length > 0 ? item.store_ids : [-1]);
            }, 10);
          });
        }
      }
    }
  };

  const saveDetail = async () => {
    const getStoreIds = () => {
      if (filterStatus === 0) {
        return [];
      } else {
        if (selectedList.filter((item) => item === -1).length > 0) {
          return [];
        } else {
          return selectedList;
        }
      }
    };

    if (checkRequired()) {
      const oParams: any = {
        title,
        content,
        from: isStartInfinite ? null : startDate,
        to: isEndInfinite ? null : endDate,
        isPublished: isShow,
        permission_groups: [
          {
            permission_type: filterStatus,
            store_ids: getStoreIds(),
          },
        ],
      };
      if (notice_id && Number(notice_id) !== -1) {
        oParams['notice_id'] = Number(notice_id);

        const oRes = await NoticeController.updateNotice(oParams);
        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          if (oResponse.data) {
            toast.success('공지사항을 수정했어요');
          } else {
            toast.error('공지사항 수정 에러');
          }
        }
      } else {
        const oRes = await NoticeController.createNotice(oParams);
        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          if (oResponse.data) {
            toast.success('공지사항을 생성했어요');
          } else {
            toast.error('공지사항 생성 에러');
          }
        }
      }
    } else {
      if (selectedList.length === 0) {
        toast.error('대상 매장 혹은 호텔을 지정해주세요');
      } else toast.error('내용을 입력해주세요');
    }
  };

  useEffect(() => {
    getHotelList();

    if (notice_id && Number(notice_id) !== -1) {
      getdetail();
    }
  }, []);

  useEffect(() => {
    getStoreMetaByHotel();
    console.log('hotel', selectedHotel);
  }, [selectedHotel]);

  useEffect(() => {
    console.log('selectedList', selectedList);
  }, [selectedList]);

  // 필수 확인
  const checkRequired = () => {
    if (title.length > 2 && content && content.length > 10) {
      if (filterStatus === 0) return true;
      if (filterStatus !== 0 && selectedList.length > 0) {
        return true;
      }
    } else return false;
  };

  return (
    <Style>
      <div className="wrap">
        <div className={`contentContainer ${themeColor === 1 && 'black'}`}>
          <button className="backButton" onClick={() => navigate(-1)}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`} alt="ic" />
          </button>

          <h4>제목</h4>
          <input
            className="title"
            value={title}
            placeholder="제목을 입력해주세요"
            onChange={(e) => setTitle(e.target.value)}
          />
          <h4>등록 기간</h4>
          <div className="calendarRow">
            <div className="dateWrap">
              <div className="calendarWrap">
                <DatePicker
                  id="startDate"
                  dateFormat="yyyy-MM-dd"
                  isClearable={false}
                  locale="ko"
                  selected={startDate}
                  onChange={(e: any) => setStartDate(e)}
                  minDate={new Date()}
                  disabledKeyboardNavigation={true}
                  onFocus={(e) => {
                    e.preventDefault();
                    e.target.blur();
                  }}
                  disabled={isStartInfinite}
                />
                <label
                  className={`datePicker ${isStartInfinite && 'disabled'}`}
                  htmlFor="startDate">
                  {moment(startDate).format('YYYY / MM / DD')}
                  <img
                    className="calendar"
                    src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`}
                    alt="달력아이콘"
                  />
                </label>
              </div>
              <label htmlFor="isStartInfinite" className="checkbox">
                <h5>시작시간 지정</h5>
                <input
                  id="isStartInfinite"
                  type="checkbox"
                  checked={!isStartInfinite}
                  onChange={() => setIsStartInfinite(!isStartInfinite)}
                />
              </label>
            </div>
            <h5>~</h5>
            <div className="dateWrap">
              <div className="calendarWrap">
                <DatePicker
                  id="endDate"
                  dateFormat="yyyy-MM-dd"
                  isClearable={false}
                  locale="ko"
                  selected={endDate}
                  onChange={(e: any) => setEndDate(e)}
                  minDate={startDate}
                  disabledKeyboardNavigation={true}
                  onFocus={(e) => {
                    e.preventDefault();
                    e.target.blur();
                  }}
                  disabled={isEndInfinite}
                />
                <label className={`datePicker ${isEndInfinite && 'disabled'}`} htmlFor="endDate">
                  {moment(endDate).format('YYYY / MM / DD')}
                  <img
                    className="calendar"
                    src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`}
                    alt="달력아이콘"
                  />
                </label>
              </div>
              <label htmlFor="isEndInfinite" className="checkbox">
                <h5>종료시간 지정</h5>
                <input
                  id="isEndInfinite"
                  type="checkbox"
                  checked={!isEndInfinite}
                  onChange={() => setIsEndInfinite(!isEndInfinite)}
                />
              </label>
            </div>
          </div>
          <label htmlFor="isShow" className="checkbox title">
            <h4>게시 여부</h4>
            <input
              id="isShow"
              type="checkbox"
              checked={isShow}
              onChange={() => setIsShow(!isShow)}
            />
          </label>
          <h4>게시 대상</h4>
          <div className="selectBoxWrap">
            <button
              className={`selectBox ${filterStatus === 0 && 'active'}`}
              onClick={() => setFilterStatus(0)}>
              <h5>전체 대상</h5>
            </button>
            <button
              className={`selectBox ${filterStatus === 1 && 'active'}`}
              onClick={() => setFilterStatus(1)}>
              <h5>매장</h5>
            </button>
            <button
              className={`selectBox ${filterStatus === 2 && 'active'}`}
              onClick={() => setFilterStatus(2)}>
              <h5>호텔</h5>
            </button>
            {/* <button
              className={`selectBox ${filterStatus === 3 && 'active'}`}
              onClick={() => setFilterStatus(3)}>
              <h5>단말기</h5>
            </button> */}
          </div>
          {filterStatus > 0 && (
            <RenderFilterStore
              filterStatus={filterStatus}
              selectedList={selectedList}
              setSelectedList={setSelectedList}
              selectedHotel={selectedHotel}
              setSelectedHotel={setSelectedHotel}
              hotelList={hotelList}
              storeList={storeList}
            />
          )}
          <h4>작성 내용</h4>
          {/* <div className="editor-container">
            <MDEditor height={'100%'} value={content} onChange={onChange_content} preview="edit" />
          </div>
          <h4>미리보기</h4>
          <MDEditor.Markdown className="editor" source={content} /> */}
          {/* <div className="row">
            <h5>배경색</h5>
            <button className={`${themeColor === 0 && 'active'}`} onClick={() => setThemeColor(0)}>
              <div className="block white" />
            </button>
            <button className={`${themeColor === 1 && 'active'}`} onClick={() => setThemeColor(1)}>
              <div className="block black" />
            </button>
          </div> */}
          {content !== undefined && content !== null && (
            <>
              <Editor editText={content} setEditText={onChange_content} />
              <div className="title">
                <h4>미리보기</h4>
              </div>
              <div
                className="sun-editor-editable preview"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            </>
          )}
          <button className={`submitButton ${!checkRequired() && 'inactive'}`} onClick={saveDetail}>
            게시
          </button>
        </div>
      </div>
    </Style>
  );
};

export default NoticeEdit;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @font-face {
    font-family: '고운 돋음';
    src: url('${process.env.PUBLIC_URL}/font/Dodum-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: '고운 바탕';
    src: url('${process.env.PUBLIC_URL}/font/Batang-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: 'G마켓 산스';
    src: url('${process.env.PUBLIC_URL}/font/GmarketSansTTF.ttf') format('truetype');
  }
  @font-face {
    font-family: '청주김생체';
    src: url('${process.env.PUBLIC_URL}/font/ChungjuKimSaeng.ttf') format('truetype');
  }
  @font-face {
    font-family: '여기어때 잘난체';
    src: url('${process.env.PUBLIC_URL}/font/Jalnan2TTF.ttf') format('truetype');
  }

  .row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 10px 0 6px;
    h5 {
      color: #555;
    }
    button {
      padding: 4px;
      border-radius: 3px;
      border: 1px solid #dadada;
      background: #fafafa;
      .block {
        width: 24px;
        height: 24px;
        border-radius: 3px;
        background: #fff;
      }
      .block.black {
        background: #000;
      }
    }
    button:hover {
      background: #e1e1e1;
      border-color: #d1d1d1;
    }
    button.active {
      background: #4dd2ae;
      border-color: #4dd2ae;
    }
  }

  .inputText {
    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 4px;

      h5 {
        color: #40977f;
      }
      h4 {
        color: #555555;
      }
    }

    .title.initial {
      padding: 0 0 6px 0;
    }
  }

  .preview {
    width: 100%;
    height: 30vh;
    padding: 20px;
    border: 1px solid #dadada;
    overflow: auto;
  }

  .black {
    .sun-editor-editable,
    .preview {
      border: 1px solid #cecece;
      background-color: #000;
      color: #fff;

      hr {
        border-color: #fff;
      }

      thead {
        border-bottom: 2px solid #fff;
      }
      tr,
      td,
      th {
        border: 1px solid #fff !important;
      }
      th {
        background-color: #555;
      }
    }
  }

  .backButton {
    margin-top: -2%;
    margin-left: -8%;
  }

  .editor-container {
    height: 25dvh;
    font-family: Arial, sans-serif;
    font-size: 1rem;
    line-height: 1.5;
  }

  .w-md-editor-text-input {
    padding: 0.7rem;
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  .wrap {
    flex: 1;
    display: flex;
    justify-content: center;
    min-height: 100dvh;
    background: #f7f7f7;
  }

  input.title {
    width: 100%;
    padding: 10px 16px;
    border-radius: 5px;
    border: 1px solid #d0d7de;
    outline-color: #4dd2ae;
    font-size: 16px;
    line-height: 22px;
    color: #333;
  }

  .contentContainer {
    width: 80%;
    margin: 0 auto;
    min-height: 100dvh;
    padding: 4% 8%;
    background: #ffffff;
    border-radius: 10px;
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
      h5 {
        color: #555555;
      }
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      h5 {
        color: #40977f;
      }
    }
    .selectBox:nth-child(1) {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox:nth-last-child(1) {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
  }

  .inputArea {
    margin-top: 12px;
  }
  .inputWrap {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    input {
      flex: 1;
      border: 1px solid #aaa;
      border-radius: 5px;
      padding: 6px 10px;
      font-size: 16px;
      line-height: 24px;
      color: #555;
    }
    input:focus {
      outline-color: #4dd2ae;
    }
    input::placeholder {
      color: #cccccc;
    }

    button {
      margin-left: -8px;
      height: 38px;
      border-radius: 5px;
      padding: 0 20px;
      background: #4dd2ae;
      border: none;
    }
  }
  label.all {
    padding-right: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    h5 {
      color: #555;
      font-weight: 500;
      margin: 0;
    }
    input[type='checkbox'] {
      accent-color: #40977f;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }
  label.all:nth-child(1) {
    margin-bottom: 10px;
  }

  .resultBox {
    width: 100%;
    height: 30vh;
    border: 1px solid #aaa;
    border-radius: 5px;
    overflow-y: auto;
    margin-top: 12px;
    margin-bottom: 40px;
    .resultItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6px 20px;
      background: #fff;
      border: none;
      border-bottom: 1px solid #efefef;
    }
    .resultItem.active {
      background: #ecf5f3;
    }
    h2 {
      padding: 20px;
      margin: auto 0;
      color: #555;
    }
    input[type='checkbox'] {
      accent-color: #40977f;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }
  .resultBox.selected {
    width: 70%;
  }

  .resultBox.min {
    height: 9dvh;
    margin-bottom: 12px;
    .resultItem {
      padding: 8px 20px;
      cursor: pointer;
      h4 {
        margin: 0;
      }
    }
  }

  .mappingItem {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 12px 0;
    padding: 4px 12px 4px 20px;
    border-radius: 100px;
    background: #4dd2ae;
    cursor: pointer;
    h3 {
      color: #fff;
      font-weight: 500;
    }
  }

  .calendarRow {
    display: flex;
    gap: 6px;
    align-items: center;
    h5 {
      color: #555555;
      font-weight: 500;
      margin-top: -20px;
    }
  }

  .dateWrap {
    flex: 1;
  }
  .calendarWrap {
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;

    input {
      display: none;
    }
  }

  .datePicker {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 20px;
    border-radius: 5px;
    border: 1px solid #cecece;
    color: #a7a7a7;
    font-weight: 400;
    font-size: 16px;
    cursor: pointer;
    letter-spacing: 0.5px;

    input {
      display: none;
    }
  }
  .datePicker.disabled {
    background: #e5e5e5;
    cursor: default;
  }

  h4 {
    margin-top: 20px;
    margin-bottom: 10px;
    color: #555555;
  }

  .editor {
    height: 25dvh;
    padding: 4%;
    border-radius: 5px;
    border: 1px solid #d0d7de;
    overflow: auto;
  }

  .submitButton {
    width: 100%;
    margin-top: 20px;
    padding: 12px 0;
    background: #4dd2ae;
    color: #fff;
    border: none;
    outline: none;
    border-radius: 8px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
  }
  .submitButton.inactive {
    background: #cecece;
  }

  label.checkbox {
    width: fit-content;
    padding: 6px 0 0 6px;
    display: flex;
    align-items: center;
    gap: 4px;
    h5 {
      margin: 0;
      color: #555555;
    }
    input[type='checkbox'] {
      accent-color: #40977f;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }
  label.checkbox.title {
    padding: 30px 0 20px 0;
    gap: 8px;
    h4 {
      margin: 0;
      color: #555555;
    }
    input[type='checkbox'] {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 800px) {
    .contentContainer {
      width: 100%;
      margin: 0 auto;
      height: 100dvh;
      padding: 4%;
      background: #ffffff;
      border-radius: 10px;
    }
    .editor-container {
      height: 20dvh;
    }

    .backButton {
      margin-top: -2%;
      margin-left: -4%;
    }

    .contentContainer {
      width: 100%;
      margin: 0 auto;
      height: 100dvh;
      padding: 4%;
      background: #ffffff;
      border-radius: 10px;
    }

    input.title {
      padding: 6px 10px;
      border-radius: 5px;
      border: 1px solid #d0d7de;
      outline-color: #4dd2ae;
      font-size: 14px;
      line-height: 20px;
      color: #333;
    }

    h4 {
      margin-top: 14px;
      margin-bottom: 6px;
      font-size: 14px;
      color: #555555;
    }

    input,
    textarea {
      font-size: 14px;
    }
    .datePicker {
      padding: 9px;
      font-size: 12px;
      line-height: 16px;
    }

    .calendarWrap {
      .calendar {
        position: absolute;
        right: 12px;
        top: 8px;
        height: 18px;
      }
    }

    .editor {
      min-height: 20dvh;
    }
  }

  /* 전체 */
  .react-datepicker {
    display: flex;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25) !important;
    border-radius: 10px !important;
    border: 1px solid #4dd2ae !important;
  }

  /* 헤더 */
  .react-datepicker__header {
    background: #ecf5f3 !important;
    border-bottom: 1px solid #4dd2ae !important;
    border-radius: 10px 10px 0 0 !important;
  }
  /* 현재연월 */
  .react-datepicker__current-month {
    color: #40977f;
  }
  /* 요일 */
  .react-datepicker__day-name {
    width: 28px;
    color: #40977f;
    font-weight: 500;
  }
  /* 일요일 */
  .react-datepicker__day-name:nth-child(1) {
    color: #ff7e7e;
  }
  /* 토요일 */
  .react-datepicker__day-name:nth-child(7) {
    color: #67a4ff;
  }

  /* 날짜 */
  .react-datepicker__day {
    width: 28px;
    height: 28px;
    border-radius: 5px;
    font-weight: 400;
  }
  /* 선택불가 */
  .react-datepicker__day--disabled {
    color: #cecece !important;
    pointer-events: none;
  }

  /* 일요일 */
  .react-datepicker__day:nth-child(1) {
    color: #ff7e7e;
  }
  /* 토요일 */
  .react-datepicker__day:nth-child(7) {
    color: #67a4ff;
  }

  /* 범위 */
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background: #ecf5f3 !important;
    border: 1px solid #4dd2ae;
    color: #40977f !important;
  }
  /* 현재 */
  .react-datepicker__day--today {
    border: 1px solid #4dd2ae !important;
    color: #40977f;
    background: #ffffff;
  }
  /* 헤더 */
  .react-datepicker__header {
    background: #ecf5f3;
    border-bottom: 1px solid #4dd2ae;
    border-radius: 10px 10px 0 0;
  }
  /* 현재연월 */
  .react-datepicker__current-month {
    color: #40977f;
  }
  /* 요일 */
  .react-datepicker__day-name {
    width: 28px;
    color: #40977f;
    font-weight: 500;
  }
  /* 일요일 */
  .react-datepicker__day-name:nth-child(1) {
    color: #ff7e7e;
  }
  /* 토요일 */
  .react-datepicker__day-name:nth-child(7) {
    color: #67a4ff;
  }

  /* 말꼬리 */
  .react-datepicker__triangle {
    display: none;
  }
  /* 위치 */
  .react-datepicker-popper {
    padding: 10px 0 0 0;
  }

  /* outside */
  .react-datepicker__day--outside-month {
    background: #fff !important;
    border: none;
  }
  .react-datepicker__week {
    display: flex;
    align-items: center;
  }
  /* 범위 시작일 */
  .react-datepicker__day--range-start {
    background: #4dd2ae !important;
    border: 1px solid #4dd2ae !important;
    color: #ffffff !important;
    font-weight: 500;
  }
  /* 범위 종료일 */
  .react-datepicker__day--range-end {
    background: #4dd2ae !important;
    border: 1px solid #4dd2ae !important;
    color: #ffffff !important;
    font-weight: 500;
  }
  /* 선택한 날짜 */
  .react-datepicker__day--selected {
    background: #4dd2ae !important;
    border: 1px solid #4dd2ae !important;
    color: #ffffff !important;
    font-weight: 600;
  }
`;
